// extracted by mini-css-extract-plugin
module.exports = {"cpPageLoading":"cpPageLoading___34-hC"};